'use client';

import { Button } from '@repo/ui/button';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { UnStyledLink } from '@/components/common/link';
import { useRouter } from '@/i18n/routing';

const SignUpButton = () => {
  const t = useTranslations('common');
  const router = useRouter();

  useEffect(() => {
    router.prefetch('/auth/quick-sign-up');
  }, []);

  return (
    <Button
      asChild
      variant="primary"
      className="ml-1.5 overflow-visible rounded-3xl transition-all duration-300 vt-text-size-small sm:vt-text-size-medium"
      data-testid="header-sign-up-button"
      size="sm"
    >
      <UnStyledLink href="/auth/quick-sign-up">
        <span>{t('join-now')}</span>
      </UnStyledLink>
    </Button>
  );
};

export default SignUpButton;
